import React from "react";
import MainLoader from "../MainLoader";

const ProductsLoader = () => {
    return (
        <MainLoader />
    )
}

export default ProductsLoader;